module.exports = "/client/static/fonts/TitilliumWeb-Regular-10.ad03b05f8f9275f653a122b6d9ef0927.ttf";